import { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { authActions } from '_store';
import axios from 'axios';
import { toast } from 'react-toastify';

export { Nav };

function Nav(prop) {
    const authUser = useSelector(x => x.auth.user);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());

    const [alertData, setAlertData] = useState([]);
    const [autoCloseTime, setAutoCloseTime] = useState(5000);
    const [notificationCount, setNotificationCount] = useState(0);
    const [warningText, setWarningText] = useState('');
    const [warningColor, setWarningColor] = useState('lightblue');

    const color_DueX = 'lightblue';
    const color_DueTomorrow = 'lightblue';
    const color_DueToday = 'lightblue';
    const color_OverDue = 'lightgoldenrodyellow';
    const color_GraceEndingTomorrow = 'lightgoldenrodyellow';
    const color_GraceEndingToday = 'orange';
    const color_Deactive = 'orangered';
    const color_DeactiveTomorrow = 'orangered';
    const color_DeactiveToday = 'orangered';
    const color_DeactiveX = 'orangered';
    
    const alert_DueX = `📅 UPCOMING PAYMENT REMINDER: Your invoice payment is due in {due_days_left} day(s), please arrange payment before the due date to continue enjoying uninterrupted service.`;
    const alert_DueTomorrow = `⏰ PAYMENT DUE TOMORROW: Your invoice payment is due tomorrow, to avoid any disruption to your account, please make your payment before the due date.`;
    const alert_DueToday = `🔔 PAYMENT DUE TODAY: Please complete your payment to ensure uninterrupted access to your account and services.`;
    const alert_OverDue = `⚠️ PAYMENT OVERDUE: We have not yet received your payment, which was due on {due_date}, account remains active during the grace period remaining {grace_days_left} day(s).`;
    const alert_GraceEndingTomorrow = `🚨 URGENT PAYMENT NOTICE: Your grace period expires tomorrow, please complete payment immediately to avoid account deactivation.`;
    const alert_GraceEndingToday = `🚨 FINAL PAYMENT WARNING: Today is the last day of your grace period, failure to complete payment today may result in account deactivation.`;
    const alert_Deactive = `🚨 PAYMENT PENDING: Account deactivation in {deactivate_days_left} day(s), please pay to keep your account active.`;
    const alert_DeactiveTomorrow = `🚨 PAYMENT PENDING: Your account will be deactivated tomorrow, please make your payment to avoid service interruption.`;
    const alert_DeactiveToday = `🚨 PAYMENT PENDING: Your account is scheduled for deactivation today due to an overdue payment, please pay now to avoid service interruption.`;
    const alert_DeactiveX = `🔒 ACCOUNT DEACTIVATE: Your account will be deactivated due to non-payment, please complete payment and contact support if assistance is required.`;

    useEffect(() => {
        setNotificationCount(0);
        AutoRefresh();
      }, []);
  
    // only show nav when logged in
    if (!authUser) return null; 

    function AutoRefresh() {
        if(localStorage.getItem('pagename') !=="StudyList"){
            return null;
        }
        if (!authUser) return null;
        
        const user_key = authUser?.user_key;
        const center_key = authUser?.center_key;
        let patient_key=0;
        let report_status='';

        const dNow = new Date();
        let msg_on_last = dNow.getFullYear() + '-' +  (dNow.getMonth() + 1)  + '-' + dNow.getDate();
        
        //alert(user_key.toString() +'-' + center_key.toString()+'-' + msg_on_last);
        const url = `${process.env.REACT_APP_API_URL}/alert`;

        const request_id = randomNumberInRange(1000000, 9000000);
        const userJSON = localStorage.getItem('user');
        let validToken = true;
        if(userJSON===null){
          validToken = false;
        }
        
        if(validToken)
        {
          if(JSON.parse(userJSON)===undefined){
            validToken = false;
          }
        }
  
        if(validToken)
        {
          if(JSON.parse(userJSON).token===undefined){
            validToken = false;
          }
        }
  
        if(!validToken){
          //alert('Session expired, try to relogin.');
           //logout(); 
           //refreshExpiryToken();
          return false;
        }
        const token = JSON.parse(userJSON).token;
  
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'msg_on_last': msg_on_last,
            'request_id': request_id.toString()
          },
        };
        
        setAlertData([]);  

        try {
            axios.get(url, config).then((response) => {
                let updatedValue = {};
                updatedValue = response.data.alert_summary; 
                
                setAlertData(updatedValue);
                
                let _alertText='';
                let _due_days_left = 0;
                let _grace_days_left = 0;
                let _deactivate_days_left = 0;

                const _warning_summary = response.data.warning_summary;
                if(_warning_summary.length>0){
                  const invoice_key = _warning_summary[0].invoice_key;
                  const notification_type = _warning_summary[0].notification_type;
                  let IsWarning = false;
                  
                  if(invoice_key>0)
                  {
                    if(notification_type==='INTERNAL' ||
                       notification_type==='EMAILIN' ||
                       notification_type==='SMSWAIN' ||
                       notification_type==='SMSWAEMIN'
                    ){
                      IsWarning = true;
                    }
                  }
                  
                  if(IsWarning){
                    let _alert_color = 'lightblue';
                    const days_diff = _warning_summary[0].days_diff;

                    if(days_diff<0){
                      _due_days_left = _warning_summary[0].reminder_days_before + days_diff;
                      if(_due_days_left>0){
                        _alertText = alert_DueX;
                        _alert_color = color_DueX;
                      }
                      else if(_due_days_left === 0){
                        _alertText = alert_DueTomorrow;
                        _alert_color = color_DueTomorrow;
                      }
                      
                    }
                    else if(days_diff===0){
                      _alertText = alert_DueToday;
                      _alert_color = color_DueToday;
                    }
                    else if(days_diff>0){
                      _alertText = alert_OverDue;
                      _alert_color = color_OverDue;

                      if(_warning_summary[0].grace_days>0){
                        _grace_days_left = _warning_summary[0].grace_days - days_diff;
                        if(_grace_days_left === 0){
                          _alertText = alert_GraceEndingToday;
                          _alert_color = color_GraceEndingToday;
                        }
                        else if(_grace_days_left === 1){
                          _alertText = alert_GraceEndingTomorrow;
                          _alert_color = color_GraceEndingTomorrow;
                        }
                      }
                      else{
                        _grace_days_left = -1;
                      }

                      if(_alertText!=='' && _warning_summary[0].deactivate_after_days>0){
                        if(_grace_days_left<0){
                          _alertText='';
                        }
                      }

                      if(_alertText==='' && _warning_summary[0].deactivate_after_days>0){
                        _alertText = alert_DeactiveX;
                        _alert_color = color_DeactiveX;

                        _deactivate_days_left = _warning_summary[0].deactivate_after_days - days_diff;
                        if(_deactivate_days_left === 0){
                          _alertText = alert_DeactiveToday;
                          _alert_color = color_DeactiveToday;
                        }
                        else if(_deactivate_days_left === 1){
                          _alertText = alert_DeactiveTomorrow;
                          _alert_color = color_DeactiveTomorrow;
                        }
                        else if(_deactivate_days_left > 1){
                          _alertText = alert_Deactive;
                          _alert_color = color_Deactive;
                        }
                      }
                    }

                    if(_alertText!==''){
                      _alertText = _alertText.replace('{due_days_left}', _due_days_left);
                      _alertText = _alertText.replace('{grace_days_left}', _grace_days_left);
                      _alertText = _alertText.replace('{deactivate_days_left}', _deactivate_days_left);

                      let _due_date = _warning_summary[0].due_date;
                      _due_date = new Date(_due_date).toLocaleDateString("en-GB").replace(/\//g, '-');
                      _alertText = _alertText.replace('{due_date}', _due_date);

                      setWarningText(_alertText);
                      setWarningColor(_alert_color);
                    }
                  }
                }

                if(_alertText===''){
                  document.getElementById('divHeaderWarning_mobile').style.display='none';
                  document.getElementById('divHeaderWarning_desktop').style.display='none';
                }
                else{
                  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                    document.getElementById('divHeaderWarning_mobile').style.display='flex';
                  }
                  else{
                    document.getElementById('divHeaderWarning_desktop').style.display='flex';
                  }
                }
                 
                var imgNotifyEmpty = document.getElementById('imgNotificationEmpty');
                var divNotify  = document.getElementById('divNotification');
                var divAlertsStatus  = document.getElementById('divAlertsStatus');
                let notification_count = 0;
                divNotify.title='';
                if(updatedValue !== null){
                    if(updatedValue.length > 0){
                        notification_count = updatedValue[0].notification_count;
                        if(updatedValue.length === 1){
                            divNotify.title= updatedValue[0].msg_desc + ', Ref: ' + updatedValue[0].patient_id + ' ' + updatedValue[0].patient_name + ', Status: ' + updatedValue[0].report_status;
                        }
                        //notifyInfo('New Alerts : ' + updatedValue[0].notification_count);
                    }
                    //const template = getReportContent(0, updatedValue);
                    
                }

                setNotificationCount(notification_count);

                if(notification_count > 0){
                    divAlertsStatus.innerHTML = '';
                    imgNotifyEmpty.style.display='none';
                    divNotify.style.display='';
                }
                else{
                    divAlertsStatus.innerHTML = 'No alert found!';
                    imgNotifyEmpty.style.display='';
                    divNotify.style.display='none';
                }

                if(authUser?.user_type === 'D' || authUser?.user_type === 'R'){
                    setTimeout(function() {
                        AutoRefresh();
                    }, 1000 * (60*1));
                }
            })
           .catch(error => {
            //alert(error);
            if(error.response.data.message==='Unauthorized')
            {
              ;//alert('Unauthorized session, try to relogin.');
            }
            else{
            
              ;//alert(error.response.data.message);
            }
           });
    
          } catch (err) {
            //alert('error');
              //alert(err.code);
            if (err.code === '404') {
              //setError('Object does not exist.')
              return
            }
          }
    }

    const openAlert = (event, param, action_tag) => {
      event.preventDefault();
      
      if(param === 'OPEN'){
        AutoRefresh();
      }

      let modal = document.querySelector("#divAlertModal");
      modal.classList.toggle("closed");
    };

    function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const notifyInfo = (msgValue) => {
        setTimeout(function () {
            toast.info(msgValue, {
              position: "top-right"
            });
          }, 100);
      };

    return (
        <>
          <div id="divHeaderWarning_mobile" style={{display:"none"}} className="bg-amber-50 border-b border-amber-200 text-amber-900 w-full sticky top-0 z-50 flex flex-col md:flex-row items-center justify-between w-full overflow-hidden relative py-3 flex items-center select-none">
            <div className="flex whitespace-nowrap animate-marquee-custom pause-on-hover cursor-pointer">
              <span className="text-sm font-medium px-4 flex items-center gap-12">
                      <span>{warningText}</span>
                      <span>{warningText}</span>
              </span>
              <span className="text-sm font-medium px-4 flex items-center gap-12">
                <span>{warningText}</span>
                <span>{warningText}</span>
              </span>
            </div>
          </div>
        

        <nav className="sb-topnav navbar navbar-expand navbar-dark bg-gradient-1">
            
            <a className="navbar-brand ps-3 nav-header" href="index.html">MYTSOFT</a>
            
            <button type="button" className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" onClick={prop.showHideMenu}><i className="fa fa-bars" aria-hidden="true"></i></button>
            
            <div id="divHeaderWarning_desktop" style={{display:"none", color:{warningColor}, backgroundColor:"lightgoldenrodyellow", marginLeft:"50px", marginRight:"10px"}} className="w-full overflow-hidden relative py-1 flex items-center select-none">
            <div className="flex whitespace-nowrap animate-marquee-custom pause-on-hover cursor-pointer">
              <span className="text-sm font-medium px-4 flex items-center gap-12">
                      <span>{warningText}</span>
                      <span>{warningText}</span>
              </span>
              <span className="text-sm font-medium px-4 flex items-center gap-12">
                <span>{warningText}</span>
                <span>{warningText}</span>
              </span>
            </div>
          </div>

            <ul className="navbar-nav ms-auto ms-md-0 me-lg-4 margin-auto">
                <img id="imgNotificationEmpty" src="../../img/ringing.png" height="25px" width="25px" alt="" className="mt-1 me-1" style={{cursor: "pointer"}} onClick={event => openAlert(event, 'OPEN')} />
                <div id="divNotification" style={{display:"none"}}>
                    <img id="imgNotification" src="../../img/alarm-bell.png" height="25px" width="25px" alt="" className="mt-1 me-1" style={{cursor: "pointer"}} onClick={event => openAlert(event, 'OPEN')} />
                    <span className="badge notification-alert-badge rounded-pill badge-primary">{notificationCount}</span>
                    
                </div>
                <span style={{width:"30px"}}>&nbsp;</span>
                <img id="imgProfile" src="../../img/profile-pink.png" height="25px" width="25px" alt="" className="mt-1 me-1"  />
                
                <div className="text-white mt-2 font-roboto font-weight400 profile_text">{authUser?.user_title} {authUser?.user_name}</div>
                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" name="navbarDropdown" href=" " role="button" data-bs-toggle="dropdown" aria-expanded="false"> </a>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                        {/*<li><a className="dropdown-item" href="/">Home</a></li>
                        <li><a className="dropdown-item" href="/about">About</a></li>
                        
                        <li><a className="dropdown-item" href="/profile">Profile</a></li>*/}
                        <li><hr className="dropdown-divider" /></li>
                        <li><a className="dropdown-item" href="#!"  onClick={logout}>Logout</a></li>
                    </ul>
                </li>
            </ul>
        </nav>
        
        <div id="divAlertModal" className="modal closed">
          {/*<!--Modal content -->*/}
          <div className="alert-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" onClick={event => openAlert(event, 'CLOSE')}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Alerts</h6>
              </div>
              
              <div className="modal-body" style={{overflow:"auto", padding:"0rem"}}>
                <div id="divAlertsStatus"></div>

<div className="container">
<div className="ks-page-content">
    <div className="ks-page-content-body">
        <div className="ks-messenger">            
            <div className="ks-messages ks-messenger__messages">
                <div className="ks-body ks-scrollable jspScrollable">
                    <div className="jspContainer">
                        <div className="jspPane">
                            <ul className="ks-items"> {/* ks-item ks-from ks-unread  <li className="ks-separator">Today</li> */}
                              {alertData.map((data, i) => (
                                <li key={i} className="ks-item ks-self">
                                    <span className="ks-avatar ks-offline">
                                        {(data?.sender_type === 'D' ?  
                                            <img src="img/doctor_icon.png" alt="" width="36" height="36" className="rounded-circle"></img>
                                            : 
                                            (data?.sender_type === 'A' ?  
                                                <img src="img/admin_icon.png" alt="" width="36" height="36" className="rounded-circle"></img>
                                                : 
                                                <img src="img/user_icon.png" alt="" width="36" height="36" className="rounded-circle"></img>
                                            )
                                        )}
                                    </span>
                                    <div className="ks-body">
                                        <div className="ks-header">
                                            <span className="ks-name">
                                                {(authUser?.user_type === 'U' ?  
                                                    (data?.sender_type === 'D' ?  
                                                        <b>Doctor</b>
                                                        : <b>{data?.sender_name}</b>
                                                    )
                                                    : 
                                                    (authUser?.user_type === 'D' || authUser?.user_type === 'R' ?  
                                                        (data?.sender_type === 'U' ?  
                                                            <b>Center User</b>
                                                            : <b>{data?.sender_name}</b>
                                                        )
                                                        : 
                                                        (data?.sender_type === 'D' ?  
                                                            <b>{data?.sender_title} {data?.sender_name} ({data?.user_id})</b>
                                                            : <b>{data?.sender_name}</b>
                                                        )
                                                    )
                                                )}
                                                &nbsp;Ref: {data?.patient_id} - {data?.patient_name} (Status: {data?.report_status})
                                            </span>
                                            <span className="ks-datetime">{data?.msg_date} {data?.msg_time}</span>
                                        </div>
                                        <div className="ks-message">{data?.msg_desc}</div>
                                    </div>
                                </li>
                              ))}
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

                        
                  
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnAlertClose" onClick={event => openAlert(event, 'CLOSE')}> CLOSE </button></div>
                </div>
              </div>

          </div>
        </div>
        
        </>
    );
}